interface PleaseWaitModalProps {
  onDismiss: () => void;
}

export const PleaseWaitModal = ({ onDismiss }: PleaseWaitModalProps) => (
  <>
    <div className='absolute inset-0 z-40 rounded-[12px] bg-[#181818] opacity-[0.72]' />
    <div className='absolute inset-0 z-50 flex items-center justify-center p-4'>
      <div className='w-full rounded-[10px] border border-[#e4e4e4]/12 bg-[#181818] p-5'>
        <div className='flex w-full flex-col items-center gap-3'>
          <div
            className='h-8 w-8 rounded-full border-[3px] border-[#e4e4e4]/20 border-t-[#FBBF24]'
            style={{ animation: 'spin 0.8s linear infinite' }}
          />
          <p className='m-0 text-center text-[20px] font-[590] leading-[26px] text-[#e4e4e4]/92'>
            Playcast is still installing
          </p>
          <p className='m-0 text-center text-[14px] font-normal leading-[20px] text-[#e4e4e4]/55'>
            Host Mode can&apos;t start while Playcast is installing. Try again shortly.
          </p>
          <button
            type='button'
            onClick={onDismiss}
            className='w-full min-h-[44px] rounded-full border-none bg-[#FBBF24] px-4 py-3 text-[15px] font-semibold text-[#141414] cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98]'
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  </>
);
